import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import moment from 'moment';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-add-disponibility',
  templateUrl: './add-disponibility.component.html',
  styleUrl: './add-disponibility.component.scss',
})
export class AddDisponibilityComponent implements OnInit {
  toDay: any;
  formGroup: FormGroup =
    this.data?.fromDate && this.data?.toDate
      ? this.fb.group({
          start: [
            moment(this.data?.fromDate).format('YYYY-MM-DD'),
            Validators.required,
          ],
          end: [
            moment(this.data?.toDate).format('YYYY-MM-DD'),
            Validators.required,
          ],
        })
      : this.fb.group({
          start: [
            moment(this.data.date).format('YYYY-MM-DD'),
            Validators.required,
          ],
          end: [
            moment(this.data.date).format('YYYY-MM-DD'),
            Validators.required,
          ],
        });
  removeDisponibility: boolean;
  constructor(
    public dialogRef: MatDialogRef<AddDisponibilityComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private fb: FormBuilder
  ) {
    this.removeDisponibility = data.removeDisponibility;
    let myDate = moment(new Date())
      .format('YYYY-MM-DD')
      .replace(/(\d{2})-(\d{2})-(\d{4})/, '$2/$1/$3');
    this.toDay = moment(new Date()).format('YYYY-MM-DD');
  }
  ngOnInit(): void {
   this.formGroup.get('start')?.valueChanges.subscribe((startDate: string) => {
    const endDateControl = this.formGroup.get('end');
    if (startDate && (!endDateControl?.value || new Date(endDateControl.value) < new Date(startDate))) {
      endDateControl?.setValue(startDate);
    }
    const minDate = new Date(startDate);
    endDateControl?.setValidators([
      Validators.required,
      (control) => {
        const selectedDate = new Date(control.value);
        return selectedDate >= minDate ? null : { minDate: true };
      }
    ]);
    endDateControl?.updateValueAndValidity();
  });
  }
  onDialogClose(): void {
    this.dialogRef.close();
  }
  submitDialog(): void {
    this.dialogRef.close(this.formGroup.value);
  }
}
